export enum LabelPosition {
  Top = 'top',
  Left = 'left',
  Right = 'right',
}
